/* eslint-disable no-console */
import React, { useContext } from 'react';
import { Redirect } from 'react-router';
import { Login as LogIn, AppContext, Logout, Layout, LoginIcon } from '@ctsu/loader';



export const LoginCore = () => {
  const params = new URLSearchParams(window.location.search);
  const hasRedirectTo = params.has('redirectTo');
  const redirectTo = params.get('redirectTo') || '/';
  const appName = process.env.REACT_APP_NAME;
  const appOrigin = process.env.REACT_APP_ORIGIN;
  const relayState = hasRedirectTo ? redirectTo : process.env.REACT_APP_RELAY_STATE;

  console.log('Redirecting to:', relayState);
  return (
    <LogIn
      page={<Redirect to={redirectTo} />}
      appName={appName}
      appOrigin={appOrigin}
      relayState={relayState}
      buttonText="Log In"
      loadingText="Logging in..."
      buttonIcon={<LoginIcon />}
      buttonClassName="btn turquoise font-lg padded"
      buttonTooltip="Login with CTEP-IAM"
      iconPosition="right"
      onError={(error) => console.log(error)}
    />
  );
};

export const Login = () => {
  return (
    <Layout
      welcomeMessage="Welcome to Protocol"
      loginAction={<LoginCore />}
      aboutSection={
        <div className="color-dark-grey font-btn" style={{ lineHeight: '1.6' }} data-id="welcomeContent">
          The<span className="font-bold"> Protocols </span>application displays
          <span className="font-bold mx-1">
            protocol/study data, including statuses, versions, countries and network
            participation, study agents, PSRs, CIRB information, and OPEN/Website and
            TRIAD configuration settings for clinical trials
          </span>
          <span className="mx-1">
            across NCI-supported research networks. LPO and CTSU staff with appropriate
            privileges are able
          </span>
          <span className="font-bold mx-1">
            to manage specific protocol data in this application.
          </span>
        </div>
      }
    />

  )
}



export const GotoLogin = () => <Redirect to="/login" />;

export const Protector = (Base) => {
  const ProtectedComponent = (props) => {
    const context = useContext(AppContext);
    const { session } = context;
    const authenticated = session?.username;
    if (authenticated) {
      return <Base {...props} />;
    }

    return <Redirect to="/login" />;
  };
  
  return ProtectedComponent;
};

export const protect = (comp) => Protector(comp);

export const LogOut = () => <Logout logout={<GotoLogin />} />;
